// extracted by mini-css-extract-plugin
export default {"headline":"RjBs0cL8bOOpY6oa_lCo","teasers":"HthHknXpvmBtFEywGaoK","teaser":"guVSvkflhFBq2i3bp1jz","teaserContent":"P7Yccb2pXr4HnuHj8nFa"};